<template>
  <div>
    <CardComponent ref="card" variant="tertiary">
      <template #header>
        {{ $t('generic-str.key-word') }}
        <ul class="actions top-right">
          <li>
            <a role="button" @click="fetch()">
              <span class="material-symbols-outlined"> refresh </span>
            </a>
          </li>
          <li>
            <a role="button" @click="$refs['create-keyword'].show()">
              <span class="material-symbols-outlined"> add </span>
            </a>
          </li>
        </ul>
      </template>
      <TableComponent :busy="loading" :fields="fields" :items="keywords">
        <template #cell(actions)="slotProps" class="x">
          <ButtonComponent class="mx-auto" @click="remove(slotProps.item)">
            <span class="material-symbols-outlined">delete</span>
          </ButtonComponent>
        </template>
      </TableComponent>
      <PaginationComponent v-model="currentPage" :totalPages="totalPages" @change="fetch" />
    </CardComponent>
    <!-- Sidebar - Keywords -->
    <SidebarComponent ref="create-keyword" :title="$t('generic-str.status.lbl-new')" backdrop>
      <FormComponent ref="store-keyword" @submit="save">
        <TextAreaComponent v-model="form.word" :label="$t('key-word-component.label')"></TextAreaComponent>
      </FormComponent>
      <template #footer>
        <div class="d-flex justify-content-between">
          <ButtonComponent variant="secondary" @click="$refs['create-keyword'].hide()">
            {{ $t('app.cancel') }}
          </ButtonComponent>
          <ButtonComponent :loading="isSending" @click="$refs['store-keyword'].submit()">
            {{ $t('app.create') }}
          </ButtonComponent>
        </div>
      </template>
    </SidebarComponent>
    <!-- Sidebar - Edit Keywords -->
    <SidebarComponent ref="kewywordsEdit" :title="$t('generic-str.edit')" backdrop>
      <form @submit.prevent="saveEdit">
        <div class="modal-body">
          <div class="form-body">
            <div class="form-group row">
              <label class="control-label text-left col-md-12 text-left-m">{{ $t('key-word-component.label') }}</label>
              <div class="col-md-12">
                <textarea v-model="data.word" type="text" class="form-control"></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="hide">
            {{ $t('generic-str.cancel') }}
          </button>
          <button :class="{ 'qt-loader qt-loader-mini qt-loader-right': isSending }" :disabled="isSending" type="submit" class="btn btn-primary">
            {{ $t('generic-str.save') }}
          </button>
        </div>
      </form>
    </SidebarComponent>
  </div>
</template>

<script>
import moment from 'moment-timezone';
import Swal from 'sweetalert2';
import SmsService from '@/services/sms.service';
import CardComponent from '@/components/CardComponent.vue';
import SidebarComponent from '@/components/SidebarComponent.vue';
import FormComponent from '@/components/form/FormComponent.vue';
import TextAreaComponent from '@/components/form/TextAreaComponent.vue';
import ButtonComponent from '@/components/ui/ButtonComponent.vue';
import TableComponent from '../TableComponent.vue';
import PaginationComponent from '../PaginationComponent.vue';

export default {
  name: 'KeywordsTable',
  components: {
    CardComponent,
    SidebarComponent,
    FormComponent,
    TextAreaComponent,
    ButtonComponent,
    TableComponent,
    PaginationComponent,
  },
  data() {
    return {
      fetched: false,
      loading: true,
      isSending: false,
      paginate: {},
      fields: [
        { key: 'created_at', formatter: (value) => moment(value).format('DD/MM/YYYY HH:mm:ss') },
        {
          key: 'word',
        },
        'actions',
      ],
      keywords: [],
      selectedKeywords: [],
      form: {
        page: 1,
        channel: 'rcs',
        word: '',
      },
      pages: 1,
      data: {
        id: null,
        word: '',
      },
      totalPages: 1,
      currentPage: 1,
    };
  },
  computed: {
    selectAllKeywords: {
      get() {
        if (this.keywords) {
          return this.selectedKeywords.length === this.keywords.length;
        }
        return false;
      },
      set(value) {
        const selected = [];

        if (value) {
          this.keywords.forEach((keyword) => {
            selected.push(keyword);
          });
        }

        this.selectedKeywords = selected;
      },
    },
  },
  created() {
    this.fetch();
  },
  mounted() {
    this.$root.$on('KeyWordsReload', () => {
      // your code goes here
      this.fetch();
    });
  },
  methods: {
    fetch(page = 1) {
      this.loading = true;
      this.$store
        .dispatch('fetchRcsKeywords', {
          page,
        })
        .then((response) => {
          this.keywords = response.data;
          this.totalPages = response.last_page;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    remove(keyword) {
      Swal.fire({
        title: `Remover palavra-chave "${keyword.word}"`,
        text: 'Essa ação não poderá ser desfeita',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('generic-str.yes'),
      }).then((result) => {
        if (result.value) {
          SmsService.deleteKeyword(keyword.id).then(
            () => {
              this.$modal.hide('dialog'); // Fecha o dialog após a execução do handler.
              this.fetch();
              this.$toast.show({
                title: this.$t('generic-str.success'),
                content: 'Palavra-chave removida com sucesso!',
                type: 'success',
              });
            },
            (error) => {
              this.content = error;
            },
          );
        }
      });
    },
    deleteMultiple() {
      Swal.fire({
        title: 'Remover palavras-chave?',
        text: 'Essa ação não poderá ser desfeita?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('generic-str.yes'),
      }).then((result) => {
        if (result.value) {
          const toDelete = [];
          this.selectedKeywords.forEach((item) => {
            toDelete.push(item.id);
          });
          this.isSending = true;
          SmsService.deleteMultipleKeywords({ ids: toDelete }).then(
            () => {
              this.$toast.show({
                title: this.$t('generic-str.success'),
                content: this.$t('warnings.optouts.removed-number'),
                type: 'success',
              });
              this.fetch();
              this.isSending = false;
              this.selectedKeywords = [];
            },
            (error) => {
              this.$toast.show({
                title: `${this.$t('sms.infos.filters.status.lbl-error')} ${error.code}`,
                content: error.response.data.message,
                type: 'danger',
              });
              this.isSending = false;
            },
          );
        }
      });
    },
    showKeywords() {
      this.$refs.kewywords.toggle();
    },
    showEditKeywords(id) {
      const itemToEdit = this.keywords.find((item) => item.id === id);

      if (itemToEdit) {
        this.data.id = itemToEdit.id;
        this.data.word = itemToEdit.word;
      }

      this.$refs.kewywordsEdit.toggle();
    },
    hide() {
      this.$refs.kewywords.toggle();

      this.form = {
        word: '',
      };
    },
    hideEdit() {
      this.$refs.kewywordsEdit.toggle();
    },
    save() {
      this.isSending = true;
      this.$store
        .dispatch('storeRcsKeyword', {
          word: this.form.word,
        })
        .then(
          (response) => {
            this.$refs['create-keyword'].hide();
            this.$toast.show({
              title: this.$t('generic-str.success'),
              content: this.$t('key-word-component.success'),
              type: 'success',
            });
            this.form.word = '';
            this.fetch();
          },
          (error) => {
            this.$toast.show({
              title: `${this.$t('sms.infos.filters.status.lbl-error')} ${error.code}`,
              content: error.message,
              type: 'danger',
            });
            this.isSending = false;
          },
        )
        .finally(() => {
          this.isSending = false;
        });
    },
    saveEdit() {
      this.isSending = true;
      SmsService.editKeyList(this.data).then(
        () => {
          this.hideEdit();
          this.$toast.show({
            title: this.$t('generic-str.success'),
            content: this.$t('key-word-component.update'),
            type: 'success',
          });
          this.$emit('submit');
          this.$root.$emit('KeyWordsReload');
          this.isSending = false;
        },
        (error) => {
          this.$toast.show({
            title: `${this.$t('sms.infos.filters.status.lbl-error')} ${error.code}`,
            content: error.message,
            type: 'danger',
          });
          this.isSending = false;
        },
      );
    },
  },
};
</script>

<style scoped lang="scss">
@media (min-width: 768px) and (max-width: 992px) {
  .btn-trim {
    display: none;
  }
}
.card-body {
  min-height: 200px !important;
  text-align: center;
}
.table-responsive {
  min-height: 300px;
  overflow-x: visible !important;
}
.btn i {
  line-height: 1;
  color: inherit;
}
.table-placeholder {
  margin-top: 25px;
}
.table-placeholder h5 {
  color: black !important;
}
.table-placeholder p {
  font-size: 13px;
}
.no-item {
  font-size: 60px;
}
/* Rebranding */
.eye_icon {
  color: #bfc5cb;
}
.form-group {
  label {
    color: var(--foreground);
    font-size: 16px;
    margin-bottom: 20px;
  }
  input:-ms-input-placeholder {
    text-transform: lowercase !important;
  }
  input::-webkit-input-placeholder {
    text-transform: lowercase !important;
  }
  input::placeholder {
    text-transform: lowercase !important;
  }

  #inputPassword {
    border-right-color: transparent;
    border-right-width: 0;
  }

  .icon_btn {
    display: flex;
    align-items: center;
    background-color: #fff;
    border: 1px solid var(--form-border);
    border-left-color: transparent;
    border-radius: 0.25rem;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;

    span {
      color: var(--gray-font-color);
    }
  }
}
.darkmode .rebranding .form-control,
.rebranding .form-control {
  border-right: unset !important;
}
.darkmode .form-group .icon_btn {
  background-color: var(--form-input);
  border-color: var(--form-border);
  border-left-color: transparent;
}

.header_options .input-group > input,
.header_options .input-group button {
  height: 50px;
}

.rebranding .add_person {
  cursor: pointer;
}

.rebranding .opts_card button {
  height: fit-content;
  padding: 0;
}

.rebranding .card .opts_card i {
  font-size: 22px;
  transition: 0.5s;
  padding: 5px;
}

.rebranding .card .opts_card i:hover {
  background-color: var(--background-icon-hover);
  border-radius: 5px;
}

/* Keyword */
.list-options li {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 2rem;
}

.list-options li .control-group {
  display: flex;
  gap: 10px;
  clear: both;
  width: 100%;
}

.list-options li .control-group .control {
  width: 100%;
}

.msg-optout {
  .control {
    display: flex;
    align-items: center;
  }

  .list-options span {
    font-weight: 400;
  }

  .list-options li .control-group .control {
    width: auto;
  }
}

.list-options li .control-group .control_indicator {
  float: left;
  margin-right: 10px;
}

.rebranding .purple-add {
  background-color: var(--clr-yup-purple);
  color: #fff !important;
  transition: 0.5s;
}

.rebranding .purple-add:hover {
  background-color: var(--clr-yup-purple-hover);
}

.rebranding .card {
  height: calc(100% - 1.875rem);
}

.keyword-wrapper {
  width: 100%;
  display: flex;
  flex-wrap: wrap;

  textarea {
    resize: none;
  }
}

.card-header .card-title {
  color: #697077 !important;
  font-size: 16px !important;
  font-weight: 400 !important;
  margin-top: 10px !important;
}

.header_title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.rebranding .card .card-header .header_title,
.rebranding .header_title {
  font-weight: 400;
}
</style>
